import { SET_SCANNED_CODE } from './types';

const initialState = {
  scannedCode: undefined,
};

export function barcodeScannerReducer(state = initialState, action) {
  switch (action.type) {
    case SET_SCANNED_CODE: {
      return {
        ...state,
        scannedCode: action.payload.scannedCode,
      };
    }

    default:
      return state;
  }
}
